"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _client = require("react-dom/client");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var createConfirmation = function createConfirmation(Component) {
  var unmountDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var mountingNode = arguments.length > 2 ? arguments[2] : undefined;
  return function (props) {
    var wrapper = (mountingNode || document.body).appendChild(document.createElement('div'));
    var root = (0, _client.createRoot)(wrapper);
    var promise = new Promise(function (resolve, reject) {
      try {
        root.render( /*#__PURE__*/_react["default"].createElement(Component, _extends({
          reject: reject,
          resolve: resolve,
          dispose: dispose
        }, props)));
      } catch (e) {
        console.error(e);
        throw e;
      }
    });

    function dispose() {
      setTimeout(function () {
        root.unmount();
        setTimeout(function () {
          if (wrapper && wrapper.parentNode) {
            wrapper.parentNode.removeChild(wrapper);
          }
        });
      }, unmountDelay);
    }

    return promise.then(function (result) {
      dispose();
      return result;
    }, function (result) {
      dispose();
      return Promise.reject(result);
    });
  };
};

var _default = createConfirmation;
exports["default"] = _default;